export var ImageType = /*#__PURE__*/function (ImageType) {
  ImageType["JPEG"] = "image/jpeg";
  ImageType["PNG"] = "image/png";
  return ImageType;
}({});
export var SupportedImageMetaTag = /*#__PURE__*/function (SupportedImageMetaTag) {
  SupportedImageMetaTag["XResolution"] = "XResolution";
  SupportedImageMetaTag["YResolution"] = "YResolution";
  SupportedImageMetaTag["Orientation"] = "Orientation";
  return SupportedImageMetaTag;
}({});
// http://sylvana.net/jpegcrop/exif_orientation.html
export var ExifOrientation = {
  'top-left': 1,
  // none
  'top-right': 2,
  // flip horizontal
  'bottom-right': 3,
  // rotate 180
  'bottom-left': 4,
  // flip vertical
  'left-top': 5,
  // transpose
  'right-top': 6,
  // rotate 90
  'right-bottom': 7,
  // transverse
  'left-bottom': 8 // rotate 270
};